import React, { memo } from 'react'
import { func, string, array } from 'prop-types'
import { Radio, FormElementWrapper } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'

function RemainingSortBySetting({
  sortByOptions,
  sortByValue = 'best_match',
  onSortChange,
}) {
  function handleSortChange(name) {
    return () => {
      const isDefaultValue = name === 'best_match'

      if (isDefaultValue) {
        return onSortChange({ name: 'sort_by', value: undefined })
      }

      return onSortChange({ name: 'sort_by', value: name })
    }
  }

  return (
    <div className="remaining-filters__sort-by">
      <FormElementWrapper
        title="Sorting"
        withTitleDivider
      >
        {sortByOptions.map(({ value, label }) => (
          <Radio
            key={value}
            id={value}
            label={label}
            isHighlighted
            trailLabel={value === 'best_match' ? 'default' : ''}
            onChange={handleSortChange(value)}
            isChecked={sortByValue === value}
          />
        ))}
      </FormElementWrapper>
    </div>
  )
}

RemainingSortBySetting.propTypes = {
  onSortChange: func.isRequired,
  sortByValue: string,
  sortByOptions: array.isRequired,
}

const mapStateToProps = ({
  sortByOptions, sortByValue, onSortChange,
}) => ({
  sortByOptions,
  sortByValue,
  onSortChange,
})

export default WithListingPageContext(mapStateToProps)(memo(RemainingSortBySetting))
